import React from 'react';
import { HomeBanner } from './banner/HomeBanner';
import { HomeAppleRankUp } from './HomeAppleRankUp';
import { HomeDebateTopic } from './HomeDebateTopic';
import { HomeNotice } from './notice/HomeNotice';
import { HomeAuthorMeeting } from './meeting/HomeAuthorMeeting';
import { HomeReadingBest } from './best/HomeReadingBest';
import { HomeMainActivity } from './HomeMainActivity';
import { HomeRecommend } from './HomeRecommend';

export const HomePage = () => {
  return (
    <div className="main">
      <div className="main_section1">
        <div className="inner clear">
          <HomeNotice />

          <div className="readingActivity">
            <HomeAuthorMeeting />
            <HomeMainActivity />
            <HomeRecommend />
          </div>
        </div>
      </div>

      <div className="main_section2">
        <div className="inner clear">
          <HomeBanner />
          <HomeAppleRankUp />
        </div>
      </div>
      <br />
      <HomeDebateTopic />
      <br />
      <HomeReadingBest />
    </div>
  );
}